import './VirtualizedTable.scss';

export { default as VirtualizedTable } from './VirtualizedTable';
